var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"googleMap",class:{'google-map' : true, 'google-map-mob': _vm.$vuetify.breakpoint.xsOnly}}),(Boolean(this.google) && Boolean(this.map))?[_vm._t("default",null,{"google":_vm.google,"map":_vm.map})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }